import { createSlice } from "@reduxjs/toolkit";
import deleteUser from "../../../rtk-apis/user/deleteUser";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const deleteUserSlice = createSlice({
  name: "deleteUserSlice",
  initialState,
  reducers: {
    closeUserDeleteModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(deleteUser.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deleteUser.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deleteUser.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deleteUserSlice.reducer;
export const { closeUserDeleteModal } = deleteUserSlice.actions;
